// **********************************************************
// Text Image Slider
// **********************************************************

// Slider
const textImageEle = document.querySelectorAll('.text-image__image');

textImageEle.forEach((ele) => {
  const mainSliderEl = ele.querySelector('[data-slider="text-image-slider"]');
  const thumbSliderEl = ele.querySelector('[data-slider="text-image-thumb"]');

  let thumbSwiper;

  if (thumbSliderEl) {
    thumbSwiper = new Swiper(thumbSliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      watchOverflow: true,
      freeMode: {
        sticky: false,
        momentumRatio: 0.3,
        momentumVelocityRatio: 0.3,
      },
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ele.querySelector('.swiper-button-next'),
        prevEl: ele.querySelector('.swiper-button-prev'),
      },
    });
  }

  new Swiper(mainSliderEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    autoHeight: true,
    speed: 500,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,
  });
});
